export const loadStripe = (
  setStripe: (stripe: any) => void,
  stripeKey: string
) => {
  if ((window as any).Stripe) {
    setStripe((window as any).Stripe(stripeKey))
  } else {
    const stripeEl = document.querySelector('#stripe-js')

    const setStripeOnLoad = () =>
      document
        .querySelector('#stripe-js')!
        .addEventListener('load', () =>
          setStripe((window as any).Stripe(stripeKey))
        )

    if (!stripeEl) {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://js.stripe.com/v3'
      script.id = 'stripe-js'
      document.body.appendChild(script)
      setStripeOnLoad()
    }

    if (stripeEl) {
      setStripeOnLoad()
    }
  }
}
